import React from "react";
import { BarChart } from "@mui/x-charts";
import { Box, CircularProgress } from "@mui/material";
import theme from "../../utils/theme";

const styles = {
  container: {
    width: "100%",
    height: 260,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  chart: {
    width: "100%",
    borderRadius: 2,
  },
};

const ProjectBarChart = ({ data }) => {
  // Use the provided data directly (no aggregation needed)
  const formattedPurposes = data?.map((item) => {
    let label = item.purpose_name
      .replace(/[_-]/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
    if (label.length > 12) {
      label = label.replace(/(.{10})/g, "$1\n");
    }
    return label;
  });

  const counts = data?.map((item) => item.count);

  return (
    <Box sx={styles.container}>
      {data ? (
        <BarChart
          xAxis={[
            {
              id: "purpose",
              data: formattedPurposes,
              label: "Purpose",
              labelFontWeight: "bold",
            },
          ]}
          series={[
            {
              data: counts,
              label: "RFIs", // used for tooltip header
              color: theme.palette.primary.main,
            },
          ]}
          yAxis={[{ label: "Number of RFIs" }]}
          grid={{ vertical: true, horizontal: true }}
          height={260}
          sx={{ width: "100%", borderRadius: 2 }}
          hideLegend={true}
        />
      ) : (
        <CircularProgress />
      )}
    </Box>
  );
};

export default ProjectBarChart;
